import clsx from 'clsx';
import { infoIconGray } from '../../../../assets/hostedassets';
import { FETCH_DETAILS_BANNER_COPY } from './ManagementProfileTabConstants';
import styles from './FetchDetailsBanner.module.scss';

interface FetchDetailsBannerProps {
    onFetchDetails: () => void;
    body?: string;
    ctaLabel?: string;
    className?: string;
}

// First-run prompt (D7) — a single inline info row, not dismissible. Replaced by the tab's
// existing in-progress treatment once a fetch is running (moduleFetchInFlight), so this
// component owns no loading/progress UI of its own. The CTA just opens the Unlock/Refresh
// drawer (synchronous) — no request fires from this click, so no disabled/pending state either.
function FetchDetailsBanner({
    onFetchDetails,
    body = FETCH_DETAILS_BANNER_COPY.BODY,
    ctaLabel = FETCH_DETAILS_BANNER_COPY.CTA_LABEL,
    className,
}: FetchDetailsBannerProps) {
    return (
        <div className={clsx(styles.FetchDetailsBanner, className)}>
            <img src={infoIconGray} alt="" className={styles.icon} />
            <span className={styles.text}>
                {body}{' '}
                <button type="button" className={styles.cta} onClick={onFetchDetails}>
                    {ctaLabel}
                </button>
            </span>
        </div>
    );
}

export default FetchDetailsBanner;
